export const units = [
  {
    title: 'Self Awareness',
    color: '#f15e4a',
    idStub: 'hsidentity',
  },
  {
    title: 'Stress and Regulation',
    color: '#f48955',
    idStub: 'hsstress',
  },
  {
    title: 'Decision Making Skills',
    color: '#fdd209',
    idStub: 'hsdecision',
  },
  {
    title: 'Belonging and Peer Influence',
    color: '#58c3bb',
    idStub: 'hsbelonging',
  },
  {
    title: 'Empathy and Conflict Resolution',
    color: '#09aedb',
    idStub: 'hsempathy',
  },
];

export const getStrengthsModuleIds = () => {
  return [
    'hsbelonging-self-assessment',
    'hsdecision-self-assessment',
    'hsidentity-self-assessment',
    'hsstress-self-assessment',
    'hsbelonging-self-assessment-mena',
    'hsempathy-self-assessment',
    'hsidentity-self-assessment-standard',
    'hsstress-self-assessment-mena',
  ];
};

export const getOuterSlicePath = (
  centreX: number,
  centreY: number,
  startAngleRadians: number,
  sweepAngleRadians: number,
  radius: number,
) => {
  const startX = centreX + radius * Math.cos(startAngleRadians);
  const startY = centreY + radius * Math.sin(startAngleRadians);
  const firstArcEndX = centreX + radius * Math.cos(startAngleRadians + sweepAngleRadians);
  const firstArcEndY = centreY + radius * Math.sin(startAngleRadians + sweepAngleRadians);
  const lineEndX = firstArcEndX + radius * 2.5 * Math.cos(startAngleRadians + sweepAngleRadians);
  const lineEndY = firstArcEndY + radius * 2.5 * Math.sin(startAngleRadians + sweepAngleRadians);
  const secondArcEndX = startX + radius * 2.5 * Math.cos(startAngleRadians);
  const secondArcEndY = startY + radius * 2.5 * Math.sin(startAngleRadians);

  return `M${startX},${startY} A${radius},${radius} 0 0,1 ${firstArcEndX},${firstArcEndY}, L${lineEndX},${lineEndY}, A${
    radius * 3.5
  },${radius * 3.5} 0 0,0 ${secondArcEndX},${secondArcEndY} Z`;
};

export const getOuterTextCoordinates = (
  centreX: number,
  centreY: number,
  startAngleRadians: number,
  sweepAngleRadians: number,
  radius: number,
) => {
  const secondCircumferenceX = centreX + radius * Math.cos(startAngleRadians + sweepAngleRadians * 0.5) + 30;
  const secondCircumferenceY = centreY + radius * Math.sin(startAngleRadians + sweepAngleRadians * 0.5) - 70;

  return [secondCircumferenceX, secondCircumferenceY];
};
